module.exports = __webpack_public_path__ + "img/wild_comming.d8e2e633.png";